import { useState } from "react";
import { supabase } from "@/lib/supabase";

interface AvatarGeneratorProps {
  onSelect: (url: string) => void;
  onClose: () => void;
}

interface AvatarOption {
  id: string;
  url: string;
  label: string;
  style: string;
}

// DiceBear API — fundo neutro consistente (bege/cinza claro)
function dicebearUrl(style: string, seed: string): string {
  const bg = "f5f0e8,f3f4f6,e8e8e8,f0f0f0,e5e7eb";
  return `https://api.dicebear.com/7.x/${style}/svg?seed=${encodeURIComponent(seed)}&backgroundColor=${bg}`;
}

// 50 avatares padronizados: rostos coloridos, fundo neutro
// Alternância entre adventurer (masculino) e lorelei (feminino) para variedade
const AVATAR_LIBRARY: AvatarOption[] = [
  // Masculinos (adventurer)
  { id: "m1", url: dicebearUrl("adventurer", "Mateus Oliveira"), label: "Avatar 1", style: "adventurer" },
  { id: "m2", url: dicebearUrl("adventurer", "Lucas Silva"), label: "Avatar 2", style: "adventurer" },
  { id: "m3", url: dicebearUrl("adventurer", "Gabriel Santos"), label: "Avatar 3", style: "adventurer" },
  { id: "m4", url: dicebearUrl("adventurer", "Arthur Costa"), label: "Avatar 4", style: "adventurer" },
  { id: "m5", url: dicebearUrl("adventurer", "Pedro Lima"), label: "Avatar 5", style: "adventurer" },
  { id: "m6", url: dicebearUrl("adventurer", "João Ferreira"), label: "Avatar 6", style: "adventurer" },
  { id: "m7", url: dicebearUrl("adventurer", "Enzo Pereira"), label: "Avatar 7", style: "adventurer" },
  { id: "m8", url: dicebearUrl("adventurer", "Davi Souza"), label: "Avatar 8", style: "adventurer" },
  { id: "m9", url: dicebearUrl("adventurer", "Nicolas Almeida"), label: "Avatar 9", style: "adventurer" },
  { id: "m10", url: dicebearUrl("adventurer", "Rafael Ribeiro"), label: "Avatar 10", style: "adventurer" },
  { id: "m11", url: dicebearUrl("adventurer", "Matheus Carvalho"), label: "Avatar 11", style: "adventurer" },
  { id: "m12", url: dicebearUrl("adventurer", "Bruno Martins"), label: "Avatar 12", style: "adventurer" },
  { id: "m13", url: dicebearUrl("adventurer", "Felipe Gomes"), label: "Avatar 13", style: "adventurer" },
  { id: "m14", url: dicebearUrl("adventurer", "Guilherme Rocha"), label: "Avatar 14", style: "adventurer" },
  { id: "m15", url: dicebearUrl("adventurer", "Daniel Barbosa"), label: "Avatar 15", style: "adventurer" },
  { id: "m16", url: dicebearUrl("adventurer", "Gustavo Araújo"), label: "Avatar 16", style: "adventurer" },
  { id: "m17", url: dicebearUrl("adventurer", "Leonardo Pinto"), label: "Avatar 17", style: "adventurer" },
  { id: "m18", url: dicebearUrl("adventurer", "Samuel Cunha"), label: "Avatar 18", style: "adventurer" },
  { id: "m19", url: dicebearUrl("adventurer", "Vinícius Mendes"), label: "Avatar 19", style: "adventurer" },
  { id: "m20", url: dicebearUrl("adventurer", "Thiago Dias"), label: "Avatar 20", style: "adventurer" },
  { id: "m21", url: dicebearUrl("adventurer", "Henrique Nunes"), label: "Avatar 21", style: "adventurer" },
  { id: "m22", url: dicebearUrl("adventurer", "Vitor Cardoso"), label: "Avatar 22", style: "adventurer" },
  { id: "m23", url: dicebearUrl("adventurer", "Eduardo Teixeira"), label: "Avatar 23", style: "adventurer" },
  { id: "m24", url: dicebearUrl("adventurer", "Igor Moreira"), label: "Avatar 24", style: "adventurer" },
  { id: "m25", url: dicebearUrl("adventurer", "Murilo Correia"), label: "Avatar 25", style: "adventurer" },

  // Femininos (lorelei)
  { id: "f1", url: dicebearUrl("lorelei", "Ana Clara"), label: "Avatar 26", style: "lorelei" },
  { id: "f2", url: dicebearUrl("lorelei", "Maria Fernanda"), label: "Avatar 27", style: "lorelei" },
  { id: "f3", url: dicebearUrl("lorelei", "Juliana Rocha"), label: "Avatar 28", style: "lorelei" },
  { id: "f4", url: dicebearUrl("lorelei", "Beatriz Almeida"), label: "Avatar 29", style: "lorelei" },
  { id: "f5", url: dicebearUrl("lorelei", "Larissa Mendes"), label: "Avatar 30", style: "lorelei" },
  { id: "f6", url: dicebearUrl("lorelei", "Gabriela Souza"), label: "Avatar 31", style: "lorelei" },
  { id: "f7", url: dicebearUrl("lorelei", "Amanda Costa"), label: "Avatar 32", style: "lorelei" },
  { id: "f8", url: dicebearUrl("lorelei", "Letícia Pereira"), label: "Avatar 33", style: "lorelei" },
  { id: "f9", url: dicebearUrl("lorelei", "Sophia Oliveira"), label: "Avatar 34", style: "lorelei" },
  { id: "f10", url: dicebearUrl("lorelei", "Manuela Lima"), label: "Avatar 35", style: "lorelei" },
  { id: "f11", url: dicebearUrl("lorelei", "Isabella Silva"), label: "Avatar 36", style: "lorelei" },
  { id: "f12", url: dicebearUrl("lorelei", "Valentina Santos"), label: "Avatar 37", style: "lorelei" },
  { id: "f13", url: dicebearUrl("lorelei", "Helena Ferreira"), label: "Avatar 38", style: "lorelei" },
  { id: "f14", url: dicebearUrl("lorelei", "Luiza Gomes"), label: "Avatar 39", style: "lorelei" },
  { id: "f15", url: dicebearUrl("lorelei", "Mariana Ribeiro"), label: "Avatar 40", style: "lorelei" },
  { id: "f16", url: dicebearUrl("lorelei", "Laura Martins"), label: "Avatar 41", style: "lorelei" },
  { id: "f17", url: dicebearUrl("lorelei", "Alice Barbosa"), label: "Avatar 42", style: "lorelei" },
  { id: "f18", url: dicebearUrl("lorelei", "Cecília Araújo"), label: "Avatar 43", style: "lorelei" },
  { id: "f19", url: dicebearUrl("lorelei", "Eloá Pinto"), label: "Avatar 44", style: "lorelei" },
  { id: "f20", url: dicebearUrl("lorelei", "Yasmin Cunha"), label: "Avatar 45", style: "lorelei" },
  { id: "f21", url: dicebearUrl("lorelei", "Bruna Dias"), label: "Avatar 46", style: "lorelei" },
  { id: "f22", url: dicebearUrl("lorelei", "Raquel Nunes"), label: "Avatar 47", style: "lorelei" },
  { id: "f23", url: dicebearUrl("lorelei", "Débora Cardoso"), label: "Avatar 48", style: "lorelei" },
  { id: "f24", url: dicebearUrl("lorelei", "Natália Teixeira"), label: "Avatar 49", style: "lorelei" },
  { id: "f25", url: dicebearUrl("lorelei", "Fernanda Moreira"), label: "Avatar 50", style: "lorelei" },
];

export default function AvatarGenerator({ onSelect, onClose }: AvatarGeneratorProps) {
  const [selectedAvatar, setSelectedAvatar] = useState<AvatarOption | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string>("");
  const [uploadMode, setUploadMode] = useState(false);
  const [uploadFile, setUploadFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState("");
  const [uploadSuccess, setUploadSuccess] = useState("");

  const handleSelect = (avatar: AvatarOption) => {
    setSelectedAvatar(avatar);
    setPreviewUrl(avatar.url);
    setUploadMode(false);
  };

  const handleConfirm = () => {
    if (previewUrl) {
      onSelect(previewUrl);
    }
  };

  async function handleUploadPhoto() {
    if (!uploadFile) {
      setUploadError("Selecione uma imagem.");
      return;
    }
    setUploading(true);
    setUploadError("");
    setUploadSuccess("");
    try {
      const formData = new FormData();
      formData.append("file", uploadFile);
      formData.append("fileName", uploadFile.name);

      const { data, error } = await supabase.functions.invoke('upload-avatar', {
        body: formData,
      });
      if (error || !data) throw new Error(error?.message || data?.error || "Erro no upload da foto");
      if (data.error) throw new Error(data.error);

      const publicUrl = data.url;
      if (!publicUrl) throw new Error("URL pública não retornada pelo servidor");

      setUploadSuccess("Foto enviada com sucesso!");
      onSelect(publicUrl);
    } catch (err: any) {
      setUploadError(err.message || "Erro ao enviar foto.");
    } finally {
      setUploading(false);
    }
  }

  return (
    <div className="fixed inset-0 z-[300] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-godoy-charcoal border border-godoy-gray/30 rounded-xl w-full max-w-3xl max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-5 border-b border-godoy-gray/20 flex-shrink-0">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-godoy-gold/10 border border-godoy-gold/30 flex items-center justify-center">
              <i className="ri-gallery-line text-godoy-gold text-lg" />
            </div>
            <div>
              <h2 className="font-serif text-lg font-bold text-godoy-cream">
                Escolha seu Avatar
              </h2>
              <p className="text-godoy-lightgray/60 text-xs">
                Clique para escolher
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-lg bg-godoy-black/40 hover:bg-godoy-black/60 flex items-center justify-center transition-colors"
          >
            <i className="ri-close-line text-godoy-lightgray" />
          </button>
        </div>

        {/* Toggle: Avatares / Minha Foto */}
        <div className="flex items-center gap-2 p-4 border-b border-godoy-gray/20 flex-shrink-0">
          <button
            onClick={() => {
              setUploadMode(false);
              setSelectedAvatar(null);
              setPreviewUrl("");
            }}
            className={`flex items-center gap-1.5 px-3 py-2 rounded-full text-xs font-medium whitespace-nowrap transition-all ${
              !uploadMode
                ? "bg-godoy-gold text-godoy-black"
                : "bg-godoy-black/40 text-godoy-lightgray/70 hover:bg-godoy-black/60 hover:text-godoy-lightgray"
            }`}
          >
            <i className="ri-user-smile-line" />
            Avatares
          </button>
          <button
            onClick={() => {
              setUploadMode(true);
              setSelectedAvatar(null);
              setPreviewUrl("");
            }}
            className={`flex items-center gap-1.5 px-3 py-2 rounded-full text-xs font-medium whitespace-nowrap transition-all ${
              uploadMode
                ? "bg-godoy-gold text-godoy-black"
                : "bg-godoy-black/40 text-godoy-lightgray/70 hover:bg-godoy-black/60 hover:text-godoy-lightgray"
            }`}
          >
            <i className="ri-camera-line" />
            Minha Foto
          </button>
        </div>

        {/* Main Content */}
        <div className="flex-1 overflow-y-auto">
          <div className="flex flex-col lg:flex-row">
            {/* Content Area */}
            <div className="flex-1 p-4">
              {uploadMode ? (
                <div className="space-y-4">
                  <div className="p-6 border-2 border-dashed border-godoy-gray/30 rounded-lg bg-godoy-black/30 text-center">
                    <i className="ri-camera-line text-3xl text-godoy-gold/60 mb-3" />
                    <p className="text-godoy-cream text-sm font-medium mb-1">
                      Envie sua propria foto
                    </p>
                    <p className="text-godoy-lightgray/60 text-xs mb-4">
                      JPG ou PNG, ate 5MB
                    </p>
                    <input
                      type="file"
                      accept="image/jpeg,image/png,image/webp"
                      onChange={(e) => {
                        setUploadFile(e.target.files?.[0] || null);
                        setUploadError("");
                        setUploadSuccess("");
                      }}
                      className="mx-auto text-sm text-godoy-cream file:bg-godoy-gold file:text-godoy-black file:border-0 file:rounded-md file:px-4 file:py-2 file:text-xs file:mr-3 file:font-medium"
                    />
                    {uploadFile && (
                      <p className="text-godoy-gold text-xs mt-3 flex items-center justify-center gap-1">
                        <i className="ri-check-line" /> {uploadFile.name}
                      </p>
                    )}
                  </div>
                  {uploadError && (
                    <div className="p-3 bg-red-500/10 border border-red-500/30 rounded-md text-red-400 text-sm">
                      {uploadError}
                    </div>
                  )}
                  {uploadSuccess && (
                    <div className="p-3 bg-emerald-500/10 border border-emerald-500/30 rounded-md text-emerald-400 text-sm">
                      {uploadSuccess}
                    </div>
                  )}
                  <button
                    onClick={handleUploadPhoto}
                    disabled={uploading || !uploadFile}
                    className="w-full py-2.5 bg-godoy-gold text-godoy-black font-semibold rounded-md hover:bg-godoy-goldlight transition-all text-sm disabled:opacity-60 whitespace-nowrap"
                  >
                    {uploading ? "Enviando..." : "Usar esta Foto"}
                  </button>
                </div>
              ) : (
                <div className="grid grid-cols-5 sm:grid-cols-6 md:grid-cols-7 gap-3">
                  {AVATAR_LIBRARY.map((avatar) => (
                    <button
                      key={avatar.id}
                      onClick={() => handleSelect(avatar)}
                      className={`relative aspect-square rounded-xl overflow-hidden border-2 transition-all group ${
                        selectedAvatar?.id === avatar.id
                          ? "border-godoy-gold ring-2 ring-godoy-gold/30 scale-105"
                          : "border-godoy-gray/20 hover:border-godoy-gold/50 hover:scale-105"
                      }`}
                      title={avatar.label}
                    >
                      <img
                        src={avatar.url}
                        alt={avatar.label}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                      <div
                        className={`absolute inset-x-0 bottom-0 py-1 text-center transition-opacity ${
                          selectedAvatar?.id === avatar.id
                            ? "opacity-100 bg-godoy-gold/90"
                            : "opacity-0 group-hover:opacity-100 bg-black/60"
                        }`}
                      >
                        <span
                          className={`text-[10px] font-medium ${
                            selectedAvatar?.id === avatar.id ? "text-godoy-black" : "text-white"
                          }`}
                        >
                          {avatar.label}
                        </span>
                      </div>
                    </button>
                  ))}
                </div>
              )}
            </div>

            {/* Preview Panel */}
            <div className="lg:w-64 border-t lg:border-t-0 lg:border-l border-godoy-gray/20 p-5 flex-shrink-0">
              <p className="text-sm text-godoy-lightgray mb-4 font-medium">
                Prévia
              </p>

              {previewUrl ? (
                <div className="space-y-4">
                  <div className="relative w-32 h-32 mx-auto rounded-2xl overflow-hidden border-2 border-godoy-gold/40 bg-godoy-black/40">
                    <img
                      src={previewUrl}
                      alt="Avatar selecionado"
                      className="w-full h-full object-cover"
                    />
                  </div>

                  <p className="text-center text-xs text-godoy-lightgray/70">
                    {selectedAvatar?.label}
                  </p>

                  <button
                    onClick={handleConfirm}
                    className="w-full py-2.5 bg-godoy-gold text-godoy-black font-semibold rounded-md hover:bg-godoy-goldlight transition-all text-sm flex items-center justify-center gap-2 whitespace-nowrap"
                  >
                    <i className="ri-check-line" />
                    Usar este Avatar
                  </button>
                </div>
              ) : (
                <div className="text-center py-8">
                  <div className="w-20 h-20 mx-auto mb-3 rounded-xl bg-godoy-black/40 border border-godoy-gray/20 flex items-center justify-center">
                    <i className="ri-image-line text-godoy-lightgray/30 text-2xl" />
                  </div>
                  <p className="text-godoy-lightgray/50 text-xs">
                    {uploadMode
                      ? "Envie uma foto ou escolha um avatar"
                      : "Clique em um avatar para ver a prévia"}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="px-5 py-3 border-t border-godoy-gray/20 flex-shrink-0">
          <p className="text-godoy-lightgray/40 text-xs text-center">
            <i className="ri-information-line mr-1" />
            Escolha o avatar que mais combina com você
          </p>
        </div>
      </div>
    </div>
  );
}